<template>
    <span
        class="d-flex align-center"
        style="white-space: nowrap"
    >
            <template
                v-for="(client, index) in relatedClients.slice(0, 3)"
            >
                <router-link
                    :to="{ name: 'client_profile', params: { id: client.id }}"
                    :key="'link-'+client.id"
                >
                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <div v-on="on">
                                <ClientAvatarListItem
                                    :client-initials="client.client_initials"
                                    :color="client.color" class-name="mr-1 my-1"
                                />
                            </div>
                        </template>
                        {{ client.name }}
                    </v-tooltip>
                </router-link>
            </template>
            <ClientAvatarListItem
                v-if="relatedClients.length > 3"
                :client-initials="'+'+(relatedClients.length-3).toString()" color="grey"
                class-name="mx-0 my-1"
            />
    </span>
</template>

<script>
import ClientAvatarListItem from "../../../components/ClientAvatarListItem.vue";

export default {
    name: "RelatedClientsField",
    components: {ClientAvatarListItem},
    props: {
        relatedClients: {
            type: Array,
            required: true
        }
    },
}

</script>

<style scoped lang="scss">

</style>